import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { CheckboxComponent } from '../../../ui/checkbox/checkbox.component';
import { BaseModalComponent } from '../../base-modal/base-modal.component';

@Component({
  selector: 'mb-base-confirmation',
  templateUrl: './base-confirmation.component.html',
  styleUrls: ['./base-confirmation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BaseModalComponent, CheckboxComponent, TranslatePipe],
})
export class BaseConfirmationComponent {
  public remember = false;
  @Input() headline!: string;
  @Input() text!: string;
  @Input() cancelLabel!: string;
  @Input() confirmLabel!: string;

  @Output() confirm = new EventEmitter<{ remember: boolean }>();
  @Output() requestCancel = new EventEmitter();
}
